import { render, staticRenderFns } from "./Savannah.vue?vue&type=template&id=340a8a28&scoped=true&"
import script from "./Savannah.vue?vue&type=script&lang=js&"
export * from "./Savannah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340a8a28",
  null
  
)

export default component.exports